// MainFeatureListing.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCar, FaGasPump, FaRoad, FaBolt } from 'react-icons/fa';
import SpecItem from './SpecItem';

const MainFeatureListing = ({ listing }) => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-white shadow-xl hover:shadow-2xl transition-shadow rounded-[2px] overflow-hidden flex flex-col">
      {/* Możesz zmniejszyć lub zwiększyć wysokość obrazka wg potrzeb */}
      <div className="relative h-[200px] sm:h-[240px] md:h-[280px]">
        <img 
          src={listing.images[0]} 
          alt={listing.title}
          className="w-full h-full object-cover rounded-t-[2px]"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-[#35530A] text-white px-3 py-1 rounded-[2px] text-sm font-medium">
            Wyróżnione
          </span>
        </div>
      </div>

      {/* Treść karty */}
      <div className="p-6 flex flex-col">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {listing.title}
          </h2>
          <p className="text-lg text-gray-700">
            {listing.description}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-x-8 gap-y-4 mb-4">
          <SpecItem icon={<FaCar />} label="Rok produkcji" value={listing.year} />
          <SpecItem icon={<FaGasPump />} label="Rodzaj paliwa" value={listing.fuelType} />
          <SpecItem icon={<FaRoad />} label="Przebieg" value={`${listing.mileage} km`} />
          <SpecItem icon={<FaBolt />} label="Moc silnika" value={listing.power} />
        </div>
        <p className="text-base text-gray-600">
          {listing.description}
        </p>
      </div>

      {/* Pasek z ceną i przyciskiem */}
      <div className="px-4 sm:px-5 py-3 sm:py-4 bg-[#35530A] flex justify-between items-center">
        <div>
          <span className="text-white text-sm mb-1">Cena:</span>
          <span className="text-xl sm:text-2xl font-bold text-white ml-2">
            {listing.price.toLocaleString('pl-PL')} zł
          </span>
        </div>
        <button
          onClick={() => navigate(`/listing/${listing._id}`)}
          className="bg-white text-[#35530A] px-4 sm:px-6 py-2 sm:py-2.5 rounded-[2px] hover:bg-gray-50 transition-colors text-sm font-medium"
        >
          Szczegóły
        </button>
      </div>
    </div>
  );
};

export default MainFeatureListing;
